import {ArrowType, LayoutType, StyleLine, StyleShape, TypeLine } from '../types';

export const ProjectData = {
    name: "",
    description: "",
    ispublic: false,
    allowcomments: false,
    owner: "",
    backgroundcolor: "#ffffff",
    defaultshapetype: StyleShape[0].value,
    defaultedgetype: StyleLine[0].value,
    defaultconnectiontype: TypeLine[0].value,
    createdon: new Date('1995-12-17T03:24:00'),
    layout: LayoutType[0].value,
    themebordercolor: "#393939",
    themeborderwidth: 2,
    themeelementcolor: "#FCA311",
    themeedgeshowlabel: false,
    themeedgecolor: "#393939",
    themetextshowlabel: true,
    themetextcolor: "#e9ff00",
    themetextsize: 18,
    themetextborderwidth: 0,
    themetextbordercolor: "#E5E5E5",
    edgearrows: ArrowType[1].value,
    elementsize: 100,
    elementspacing: 3,
    dynamicsize: false
}